import * as React from "react";
import styled from "styled-components";
import { useField } from "formik";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { Input, Button } from "components/bootstrap";
import { Select } from "components/common";
const StyledSelect = styled(Select)`
  flex: 1 1 auto;
  min-width: 0;
`;
const StyledButton = styled(Button)`
  flex: 0 0 auto;
  margin-left: 0.5rem;
  white-space: nowrap;
`;
function CachePicker({ onCreateClick, caches = [] }) {
  const [, { value, touched, error }, { setTouched, setValue }] = useField("cache_id");
  const sortedCaches = caches.map((inCache) => ({ value: inCache.id, label: `${inCache.title} (${inCache.name})` })).sort((a, b) => naturalSort(a.label.toLowerCase(), b.label.toLowerCase()));
  const errorMessage = touched ? error : "";
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "cache-select",
      label: "Cache",
      required: true,
      bsStyle: errorMessage ? "error" : void 0,
      labelClassName: "d-block mb-1",
      wrapperClassName: "d-block",
      formGroupClassName: "mb-3"
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      StyledSelect,
      {
        placeholder: "Select a cache",
        clearable: false,
        options: sortedCaches,
        onBlur: () => setTouched(true),
        onChange: (v) => setValue(v),
        value
      }
    ), /* @__PURE__ */ React.createElement(StyledButton, { type: "button", "aria-label": "Create Cache", onClick: onCreateClick }, "Create Cache")),
    /* @__PURE__ */ React.createElement("div", { className: `mb-1 ${errorMessage ? "text-danger" : "text-muted"}` }, errorMessage || "Select an existing cache")
  ));
}
export default CachePicker;
